<template>
	<div class="container-fluid">
		<transition
			:name="$settings.routerAnimation"
			mode="out-in"
		>
			<keep-alive :include="['Error404','ErrorOffline']">
				<router-view />
			</keep-alive>
		</transition>
		<env-bar />
	</div>
</template>

<script>
import EnvBar from '@/system/layouts/public/env-bar';

export default {
	name: 'PublicLayout',
	components: {
		EnvBar
	}

};
</script>

<style lang="scss" module>
	.layout{
		display: flex;
	}

	.content{
		display: flex;
		height: 100%;
		width: 100%;
	}
</style>
